import ImportStatus from "@mapmycustomers/shared/enum/imports/ImportStatus";
import Import from "@mapmycustomers/shared/types/imports/Import";

import importComplete from "@app/assets/imports/import-complete.svg";
import importError from "@app/assets/imports/import-error.svg";
import importProgress from "@app/assets/imports/import-progress.svg";
import importQueue from "@app/assets/imports/import-queue.svg";
import importWarning from "@app/assets/imports/import-warning.svg";

import doesImportHaveSkipFile from "./doesImportHaveSkipFile";

const importStatusToImage = {
  [ImportStatus.COMPLETED]: importComplete,
  [ImportStatus.ERRORED]: importError,
  [ImportStatus.QUEUED]: importQueue,
  [ImportStatus.RUNNING]: importProgress,
} as const;

const getImage = (importRecord?: Import): string => {
  if (doesImportHaveSkipFile(importRecord)) {
    return importWarning;
  }
  return importStatusToImage[importRecord?.status ?? ImportStatus.QUEUED];
};

export default getImage;
